/**
 * These theme tokens are manually updated and are not generated from Figma tokens. These will eventually be generated.
 */

import { xUnits } from '../../../UNSAFE_Theme';
import { colorSchemeVars, typographyVars } from '../themeContract.css';

export const base = {
  cursor: {
    clickable: 'pointer'
  },
  boxShadow: {
    xs: `rgba(${colorSchemeVars.boxshadow.shadowcolor}, .12) 0 ${xUnits(0.25)} ${xUnits(1)} 0`,
    sm: `rgba(${colorSchemeVars.boxshadow.shadowcolor}, .16) 0 ${xUnits(1)} ${xUnits(2)} 0`,
    md: `rgba(${colorSchemeVars.boxshadow.shadowcolor}, .2) 0 ${xUnits(1.5)} ${xUnits(3)} 0`,
    lg: `rgba(${colorSchemeVars.boxshadow.shadowcolor}, .24) 0 ${xUnits(2)} ${xUnits(4)} 0`,
    xl: `rgba(${colorSchemeVars.boxshadow.shadowcolor}, .28) 0 ${xUnits(3)} ${xUnits(5)} 0`
  },
  borderRadius: {
    sm: xUnits(0.5),
    md: xUnits(1),
    lg: xUnits(1.5),
    xl: xUnits(2)
  }
};

export const collection = {
  listRowHeight: xUnits(12),
  listCellPaddingVertical: xUnits(3),
  sparkleImg: 'url(./images/AI-Sparkle.gif), url(../../css/redwood/images/AI-Sparkle.gif)'
};

export const dvt = {
  label: {
    sm: {
      fontSize: typographyVars.body.xs.fontSize
    },
    md: {
      fontSize: typographyVars.body.sm.fontSize
    },
    lg: {
      fontSize: typographyVars.body.md.fontSize
    }
  }
};
